import * as React from "react";
import { ROUTES } from "common/routes";
import { Route, Routes } from "react-router-dom";
import { EventsRoutes } from "../../v2/EventsRoutes";

const EventDashboard = React.lazy(() => import("components/Event/Dashboard/EventDashboard"));
const EventDetailCorporate = React.lazy(() => import("components/Event/Corporate/EventDetailCorporate"));
const ComEvent = React.lazy(() => import("components/Event/ComEvent/ComEvent"));
const EventInvitation = React.lazy(() => import("components/EventInvitation/EventInvitation"));
const EventGroupView = React.lazy(() => import("components/Event/Corporate/EventGroups/EventGroupView"));
const Page404 = React.lazy(() => import("components/layout/ErrorPage/PAGE404"));
const Page500 = React.lazy(() => import("components/layout/ErrorPage/PAGE500"));
const Page503 = React.lazy(() => import("components/layout/ErrorPage/PAGE503"));

export const AppRoutes: React.FunctionComponent = () => {
  return (
    <React.Suspense fallback={""}>
      <Routes>
        <Route path={ROUTES.HOME} element={<EventDashboard />} />
        <Route path={ROUTES.EVENTS_DASHBOARD} element={<EventDashboard />} />
        <Route path={ROUTES.EVENT_DETAIL} element={<EventDetailCorporate />} />
        <Route path={ROUTES.EVENT_INVITATION_COMEVENT_ACTION} element={<ComEvent />} />
        <Route path={ROUTES.EVENT_INVITATION_ROADSHOW_ACTION} element={<EventInvitation />} />
        <Route path={ROUTES.EVENT_INVITATION_ROADSHOW} element={<EventInvitation />} />
        <Route path={ROUTES.EVENT_SUMMARY_ROADSHOW} element={<EventGroupView />} />
        <Route path={ROUTES.PAGE_404} element={<Page404 />} />
        <Route path={ROUTES.PAGE_500} element={<Page500 />} />
        <Route path={ROUTES.PAGE_503} element={<Page503 />} />
        <Route path="/v2/*" element={<EventsRoutes />} />
        <Route path="*" element={<Page404 />} />
      </Routes>
    </React.Suspense>
  );
};
